import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import React from "react";

const DateTimeFilterField = ({ label, value, onChange }) => {
  const pickerValue =
    value && dayjs(value).isValid() ? dayjs(value) : null;

  return (
    <DateTimePicker
      label={label}
      format="DD/MM/YYYY HH:mm"
      value={pickerValue}
      onChange={(newValue) => {
        if (newValue && newValue.isValid()) {
          onChange(newValue.toISOString());
        } else {
          onChange("");
        }
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          InputLabelProps: { shrink: true },
        },
      }}
    />
  );
};

export default DateTimeFilterField;
